import { render, staticRenderFns } from "./GoingViralSpotlightModuleCard.vue?vue&type=template&id=e33ad410&scoped=true"
import script from "./GoingViralSpotlightModuleCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoingViralSpotlightModuleCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GoingViralSpotlightModuleCard.vue?vue&type=style&index=0&id=e33ad410&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33ad410",
  null
  
)

export default component.exports